import TypeBadge from './TypeBadge';
import {
  formatDexNumber,
  formatHeight,
  formatName,
  formatWeight,
  ribbonsFor,
  TYPE_COLORS,
} from '../utils/pokemon';

function PokemonCard({
  pokemon,
  side,
  summary,
  loading,
  onOpen,
  onReroll,
  onReplace,
  picker,
}) {
  const sideLabel = side === 'pokemon1' ? 'left' : 'right';
  const inputId = `replace-${side}`;

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const query = new FormData(form).get('query');
    onReplace(String(query || ''));
    form.reset();
  };

  if (!pokemon) {
    return (
      <article className={`card card-${side} ${loading ? 'is-loading' : ''}`} aria-busy={loading || undefined}>
        <div className={`portrait portrait-empty ${loading ? 'skeleton' : ''}`} />
        <h2>{loading ? 'Drawing…' : `${sideLabel === 'left' ? 'Left' : 'Right'} side`}</h2>
        <p className="muted">
          {loading
            ? `Choosing the ${sideLabel} Pokémon.`
            : `Search a name or number, or draw a random matchup.`}
        </p>
        {picker || (
          <form className="slot-form" onSubmit={handleSubmit}>
            <label htmlFor={inputId}>Replace {sideLabel} side</label>
            <div className="slot-form-row">
              <input
                id={inputId}
                name="query"
                placeholder="Name or number"
                autoComplete="off"
                disabled={loading}
              />
              <button className="btn btn-secondary" type="submit" disabled={loading} aria-label={`Set ${sideLabel} side`}>
                Set
              </button>
            </div>
          </form>
        )}
        <div className="card-actions">
          <button className="btn btn-ghost" type="button" onClick={onReroll} disabled={loading} aria-label={`Reroll ${sideLabel} side`}>
            Reroll
          </button>
        </div>
      </article>
    );
  }

  const name = formatName(pokemon.name);
  const [typeColor] = TYPE_COLORS[pokemon.types[0]] || ['#e3d6c4'];
  const ribbons = ribbonsFor(side, summary);

  return (
    <article className={`card card-${side} ${loading ? 'is-loading' : ''}`} aria-busy={loading || undefined}>
      <div
        className="portrait"
        style={{ '--portrait': typeColor }}
      >
        {pokemon.sprite ? (
          <img src={pokemon.sprite} alt={`${name} artwork`} />
        ) : (
          <span className="portrait-fallback">{formatDexNumber(pokemon.id)}</span>
        )}
      </div>
      <p className="eyebrow">{formatDexNumber(pokemon.id)}</p>
      <h2>{name}</h2>
      <ul className="type-list">
        {pokemon.types.map((type) => (
          <li key={type}>
            <TypeBadge type={type} />
          </li>
        ))}
      </ul>
      <p className="meta">
        {formatHeight(pokemon.height)} · {formatWeight(pokemon.weight)} · Base total {pokemon.total}
      </p>
      {ribbons.length > 0 && (
        <ul className="ribbon-list">
          {ribbons.map((ribbon) => (
            <li key={ribbon}>{ribbon}</li>
          ))}
        </ul>
      )}
      {picker || (
        <form className="slot-form" onSubmit={handleSubmit}>
          <label htmlFor={inputId}>Replace {name}</label>
          <div className="slot-form-row">
            <input id={inputId} name="query" placeholder="Name or number" autoComplete="off" disabled={loading} />
            <button className="btn btn-secondary" type="submit" disabled={loading} aria-label={`Set ${name}`}>
              Set
            </button>
          </div>
        </form>
      )}
      <div className="card-actions">
        <button className="btn btn-secondary" type="button" onClick={onOpen} aria-label={`Details for ${name}`} disabled={loading}>
          Details
        </button>
        <button className="btn btn-ghost" type="button" onClick={onReroll} aria-label={`Reroll ${name}`} disabled={loading}>
          Reroll
        </button>
      </div>
    </article>
  );
}

export default PokemonCard;
